<script>
export default {
    name: 'IlluSmartphoneAcadomia',
    props: {
        primaryColor: {
            type: String,
            default: '#31A4A7'
        },

        secondaryColor: {
            type: String,
            default: '#313132'
        },
    }
}
</script>
<template>
    <svg
        class="base-illu illu-smartphone-acadomia"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g fill="none" fill-rule="evenodd">
            <path
                d="M32 23c-3.313 0-6 2.5-6 5.586V41h4.334v-4.965h3.333V41H38V28.586C38 25.501 35.314 23 32 23zm-1.666 9.31v-3.723c0-.857.746-1.553 1.667-1.553.92 0 1.666.696 1.666 1.553v3.723h-3.333z"
                :fill="primaryColor" class="primary-color"
            />
            <rect
                :stroke="secondaryColor" class="secondary-color"
                x="18.5"
                y="8.5"
                width="27"
                height="47"
                rx="4"
            />
            <path
                :stroke="secondaryColor" class="secondary-color"
                stroke-linecap="square"
                d="M19.5 48.5h25M19.5 14h25"
            />
            <circle :fill="secondaryColor" class="secondary-color" cx="32" cy="52" r="1" />
        </g>
    </svg>
</template>
